module.exports = __webpack_public_path__ + "img/board-template.dae56950.png";